module.exports = __webpack_public_path__ + "static/media/Extracted_Human_DNA.f4ae1b5f.svg";